import {
  getSessionStorageItem, setSessionStorageItem,
} from '@gamiphy/utils/storage';
import {
  action, makeAutoObservable, observable,
} from 'mobx';
import { CashbackPopups } from '@gamiphy/loyalty-station-desktop/store/cashbackPopups/enums';
import { CoretavaSession } from './types';

class SessionStore {
  private static readonly CORETAVA_SESSION = 'coretava';

  @observable coretavaSession: CoretavaSession = {};

  constructor() {
    makeAutoObservable(this);

    const sessionData = getSessionStorageItem(SessionStore.CORETAVA_SESSION);
    if (sessionData) {
      this.coretavaSession = JSON.parse(sessionData) as CoretavaSession;
    }
  }

  @action
  updateSession(data: Partial<CoretavaSession>): void {
    this.coretavaSession = {
      ...this.coretavaSession,
      ...data,
    };
    setSessionStorageItem(SessionStore.CORETAVA_SESSION, JSON.stringify(this.coretavaSession));
  }

  @action
  updatePopup(popup: CashbackPopups, data: Partial<{opened: boolean, dismissed: boolean}>): void {
    this.coretavaSession = {
      ...this.coretavaSession,
      popups: {
        ...this.coretavaSession.popups,
        [popup]: {
          ...this.coretavaSession.popups?.[popup],
          ...data,
        },
      },
    };
    setSessionStorageItem(SessionStore.CORETAVA_SESSION, JSON.stringify(this.coretavaSession));
  }

  @action
  clearSessionItem(key: keyof CoretavaSession): void {
    const { [key]: toBeRemoved, ...rest } = this.coretavaSession;
    this.coretavaSession = rest;
    setSessionStorageItem(SessionStore.CORETAVA_SESSION, JSON.stringify(rest));
  }
}

export default new SessionStore();
